module.exports = __webpack_public_path__ + "static/14-ac13280777c98221a4bef02c37db90b7.jpg";